import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { config } from '../config';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  clients: any = [];
  public fileDetails = new Subject<any>();
  constructor(private http: HttpClient) {
    this.clients = [];
    console.log("File Service initialized!!!!!!!", this.clients)
  }

  addFiles(data: any): Observable<any> {
    console.log("Adding Files", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "materials/files", data).subscribe((res: any) => {

        console.log('res.data.file In Service-------->>>>>>', res.data.file);
        observer.next(res.data.file);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  // PR changes 
  deleteFiles(id) {

    return new Observable((observer) => {
      this.http.delete(config.baseApiUrl + "materials/files?_id=" + id).subscribe((res: any) => {
        observer.next(res.data.file);
        // observer.complete();
      })
    })
  }
  getSingleFile(id) {
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "folder/filedetail?_id=" + id).subscribe((res: any) => {
        console.log("Get Folders : ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }

  deleteSubmissionFiles(id) {
    return new Observable((observer) => {
      this.http.delete(config.baseApiUrl + "learners/allot/files?_id=" + id).subscribe((res: any) => {
        observer.next(res.data.file);
        // observer.complete();
      })
    })
  }

  deleteLearnerSubmissionFiles(id) {
    return new Observable((observer) => {
      this.http.delete(config.baseApiUrl + "learners/remove-submission-file?_id=" + id).subscribe((res: any) => {
        observer.next(res.data.file);
        // observer.complete();
      })
    })
  }

  editClient(data: any): Observable<any> {
    console.log("Edit clients", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "clients", data).subscribe((res: any) => {
        console.log("Edited Course : ", res);
        observer.next(res.data.client);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });

  }

  deleteClient(id) {
    return new Observable((observer) => {
      this.http.delete(config.baseApiUrl + "clients?_id=" + id).subscribe((res: any) => {
        observer.next(res.data.clients);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        });

    })
  }

  deleteLocation(id) {
    return new Observable((observer) => {
      this.http.delete(config.baseApiUrl + "clients/location?_id=" + id).subscribe((res: any) => {
        observer.next(res.data.clients);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        });

    })
  }


  getFilesByMaterial(id): Observable<any> {
    console.log("Getting Files");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "materials/files?_id=" + id).subscribe((res: any) => {
        console.log("Get Files Response : ", res);
        observer.next(res.data.files);
        observer.complete();
      })
    });
  }


  addLocation(data: any): Observable<any> {
    console.log("Adding location", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "clients/location", data).subscribe((res: any) => {
        console.log("Received Sending = ", res.data.location)
        observer.next(res.data.location);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  updateLocation(data: any): Observable<any> {
    console.log("Adding location", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.put(config.baseApiUrl + "clients/location", data).subscribe((res: any) => {
        console.log("Received Sending = ", res.data.location)
        observer.next(res.data.location);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }
  // getAssignmentFileUsingAllotmentId(id): Observable<any> {
  //   console.log("Getting Files");
  //   let that = this;
  //   return new Observable<any>((observer) => {
  //     console.log("Observable");
  //     this.http.get(config.baseApiUrl + "learners/assignment/files?_id=" + id).subscribe((res: any) => {
  //       console.log("Get Files Response : ", res);
  //       observer.next(res.data.assignment.files);
  //       observer.complete();
  //     })
  //   });
  // }

  getAssignmentFileUsingAllotmentId(id): Observable<any> {
    console.log("Getting Files");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "learners/assignment/files?_id=" + id).subscribe((res: any) => {
        console.log("Get Files Response : ", res);
        observer.next(res.data.assignment.files);
        observer.complete();
      })
    });
  }


  displayFile(data) {
    this.fileDetails.next(data)
  }

  sideMenuObservable(): Observable<any> {
    return this.fileDetails.asObservable();
  }

}
